const dev = {
    baseURL: "http://localhost:7418",
    images_cdn: "https://d1osfq4ya4myls.cloudfront.net",
    netsuite_url: 'https://5615243-sb1.app.netsuite.com',
    aws_bucket: 'magna-misc-uploads',
    uploads_cdn: 'https://d37uc30p3gnl1i.cloudfront.net',
    env: "uat",
};
const uat = {
    baseURL: "http://34.197.161.10:7418",
    images_cdn: "https://d1osfq4ya4myls.cloudfront.net",
    netsuite_url: 'https://5615243-sb1.app.netsuite.com',
    aws_bucket: 'magna-misc-uploads',
    uploads_cdn: 'https://d37uc30p3gnl1i.cloudfront.net',
    env: "uat",
};

const prod = {
    baseURL: "https://prod-api.magnasalespro.com",
    images_cdn: "https://d1osfq4ya4myls.cloudfront.net",
    netsuite_url: 'https://5615243.app.netsuite.com',
    aws_bucket: 'magna-misc-uploads',
    uploads_cdn: 'https://d37uc30p3gnl1i.cloudfgiront.net',
    env: "prod",
};
module.exports = prod;

